import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-dialog-trial-ended',
    templateUrl: './dialog-trial-ended.component.html',
    // styleUrls: ['./dialog-trial-ended.component.scss'],
    standalone: false,
})
export class DialogTrialEndedComponent implements OnInit {
    @Input() showDialog = false;
    @Output() trialEndedDowngrade = new EventEmitter<void>();
    @Output() trialEndedSales = new EventEmitter<void>();
    @Output() trialEndedUpgrade = new EventEmitter<void>();

    constructor() {}

    ngOnInit(): void {}
}
